import React from "react";
import {ConversionsAlertTooltip} from "../../base/ConversionsAlertTooltip";
import {DayBar} from "./DayBar";

export class ConversionDayBar extends DayBar {
    renderCellContent() {
        if(this.props.isToday) {
            return [this.props.value, this.renderTooltip()]
        }
        else {
            return <div className={`level-bar ${this.alertCssClasses()}`} style={{height: this.props.proportion + '%'}}/>;
        }
    }

    baseCssClasses() {
        return "level-bar";
    }

    renderCellClasses() {
        if(this.props.isToday) {
            return this.todayClasses();
        } else {
            return "graphic-item";
        }
    }


    todayClasses() {
        const fluctuation = this.props.fluctuation;
        const css_class = `graphic-item -spotlight -${fluctuation} -${this.props.level.toLowerCase()}`
        const snoozed = this.props.isSnoozed ? "-snoozed" : ""
        return `${css_class} ${snoozed}`;
    }

    renderTooltip() {
        return <ConversionsAlertTooltip
                    dayNumber={this.props.dayNumber}
                    dayValue={this.props.dayValue}
                    value={this.props.value}
                    expectedValue={this.props.expectedValue}
                    dayValueByType={this.props.dayValueByType}
                    valueByType={this.props.valueByType}
                    conversionsByAccount={this.props.conversionsByAccount}
                    conversionsSource={this.props.conversionsSource}
                    fluctuationPercentage={this.props.fluctuationPercentage}
                    fluctuation={this.props.fluctuation}
        />;
    }
}
